import React, { Component } from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import { withTranslation } from 'react-i18next';
import * as queryString from 'query-string';
import { Card, CardHeader, CardFooter, CardBody, Input, Col, Button } from 'reactstrap';
import * as competencesService from '../Application/Services/competencesService';
import CompetencesTable from './Components/Tables/competencesTable';
import Pagination from './Components/shared/pagination';
import Select from 'react-select';
import debounce from 'lodash/debounce';
import CompetenceModal from './Components/Modals/competenceModal';
import swal from 'sweetalert';
import * as utils from './Services/utils';
import HelpModal from './Components/Modals/helpModal';
import { isCompanyVerified } from './Helpers/companyHelper';
import { SpinnerLoader } from './Components/shared/spinnerLoader';

const pageSizeFromLocalStore =
  localStorage.getItem('numItemsPerPageCompetences') !== null ? localStorage.getItem('numItemsPerPageCompetences') : 10;
let CompetenceParams = {
  Name: '',
  Type: null,
  PageNumber: 1,
  PageSize: pageSizeFromLocalStore,
};

class Competences extends Component {
  state = {
    showModal: false,
    // pagination
    selectedPage: 1,
    itemsPerPage: pageSizeFromLocalStore,
    totalItems: 0,
    // selects
    tags: [{ value: 10, label: '10' }],
    competences: [],
    competence: {},
    modalPurpose: '',
    CompetenceParams: CompetenceParams,
    showHelpModal: false,
    loading: true,
    pagination: {},
  };

  async componentDidMount() {
    const numItemsPerPageCompetences = localStorage.getItem('numItemsPerPageCompetences');
    CompetenceParams.Type = null;

    const parsed = queryString.parse(this.props.location.search);
    parsed['competenceName'] ? (CompetenceParams.Name = parsed['competenceName']) : (CompetenceParams.Name = '');

    const { data: competences, headers } = await competencesService.getCompetences(CompetenceParams);
    let pagination = JSON.parse(headers.pagination);

    this.setState({
      competences,
      selectedPage: 1,
      itemsPerPage: numItemsPerPageCompetences !== null ? numItemsPerPageCompetences : 10,
      totalItems: pagination.totalItems,
      loading: false,
      CompetenceParams: CompetenceParams,
      pagination,
    });
  }

  componentWillUnmount() {
    this.ClearParams();
    this.debouncedSearchByName.cancel(); // for lodash debounce
  }

  toggleHelpModal = () => {
    this.setState({ showHelpModal: !this.state.showHelpModal });
  };

  // change number of items in the table
  handleChangeSelect = async (name, newVal) => {
    CompetenceParams.PageSize = newVal.value;
    CompetenceParams.PageNumber = 1;
    const { data: competences, headers } = await competencesService.getCompetences(CompetenceParams);
    let pagination = JSON.parse(headers.pagination);

    this.setState({
      [name]: newVal,
      competences,
      itemsPerPage: newVal.value,
      selectedPage: 1,
      pagination,
    });
    localStorage.setItem('numItemsPerPageCompetences', newVal.value);
  };

  async handlePaginationSelected(selectedPageX) {
    this.setState({ loading: true });
    CompetenceParams.PageNumber = selectedPageX;
    const { data: competences, headers } = await competencesService.getCompetences(CompetenceParams);
    let pagination = JSON.parse(headers.pagination);
    this.setState({ competences, selectedPage: selectedPageX, loading: false, pagination });
  }

  // input field for searching
  searchByName = (text) => {
    CompetenceParams.Name = text;
    this.setState({ CompetenceParams: CompetenceParams });
    this.debouncedSearchByName();
  };

  debouncedSearchByName = debounce(async () => {
    CompetenceParams.PageNumber = 1;
    const { data: competences, headers } = await competencesService.getCompetences(CompetenceParams);
    let pagination = JSON.parse(headers.pagination);
    this.setState({ competences, selectedPage: 1, totalItems: pagination.totalItems, pagination });
  }, 1000);

  handleTableRequest(item, purpose) {
    const { t } = this.props;

    if (!isCompanyVerified(t)) {
      return;
    }

    this.setState({ competence: item });
    if (purpose === 'view') {
      this.setState({ showModal: true, editCompetence: false, modalPurpose: purpose });
    } else if (purpose === 'edit' || purpose === 'create') {
      this.setState({ showModal: true, editCompetence: true, modalPurpose: purpose });
    } else if (purpose === 'delete') {
      swal(utils.getWarningSwal()).then((willDelete) => {
        if (willDelete) {
          competencesService.deleteCompetence(item.id).then((response) => {
            competencesService.getCompetences(CompetenceParams).then((response2) => {
              const { data: competences, headers } = response2;
              this.setState({ competences });
            });
          });
          // .catch((error) => {
          // });
        }
      });
    } else {
    }
  }

  /*** Modal ***/
  toggle = (modalPurpose) => {
    if (modalPurpose === 'reload') {
      this.RefreshData();
      this.setState({ showModal: false });
    } else {
      this.setState({ showModal: false, modalPurpose: modalPurpose });
    }
  };

  onSelectTypeChanged = async (item) => {
    CompetenceParams.Type = item;
    await this.RefreshData();
  };

  async RefreshData() {
    CompetenceParams.PageNumber = 1;
    const { data: competences, headers } = await competencesService.getCompetences(CompetenceParams);
    let pagination = JSON.parse(headers.pagination);
    this.setState({ competences, CompetenceParams: CompetenceParams, totalItems: pagination.totalItems, pagination });
  }

  async ResetParams() {
    await this.ClearParams();
    await this.props.history.push('/competences'); // !!! in this case MUST await or queryString.parse(this.props.location.search); will not work correctly!!!

    this.RefreshData();
  }

  async ClearParams() {
    CompetenceParams.Name = '';
    CompetenceParams.PageNumber = 1;
    CompetenceParams.PageSize =
      localStorage.getItem('numItemsPerPageCompetences') !== null
        ? localStorage.getItem('numItemsPerPageCompetences')
        : 10;
    CompetenceParams.Type = null;
  }

  render() {
    const { t } = this.props;
    return (
      <ContentWrapper>
        <CompetenceModal
          competence={this.state.competence}
          showModal={this.state.showModal}
          onToggle={(purpose) => this.toggle(purpose)}
          modalPurpose={this.state.modalPurpose}
        />
        {/* <FadeIn> */}
        <div className="content-heading">
          <Col md={10}>
            {t('competences.COMPETENCES')}&nbsp;
            {/* <HelpModal
              purpose="competencesHelp"
              showModal={this.state.showHelpModal}
              onToggle={() => this.toggleHelpModal()}
            /> */}
            <small>{t('dashboard.WELCOME_BETA')}</small>
          </Col>
          <Col>
            <Button
              id="btnCreteCompetenceFromRibbon"
              data-cy="btnCreteCompetenceFromRibbon"
              color="primary"
              size="lg"
              style={{ float: 'right', marginLeft: '10px' }}
              onClick={() => this.handleTableRequest('', 'create')}
            >
              <b style={{ fontSize: 'large' }}>{t('competences.NEW')}</b>
            </Button>
          </Col>
        </div>
        {/* </FadeIn> */}
        {this.state.loading ? (
          <SpinnerLoader />
        ) : (
          // <FadeIn>
          <Card className="card-default">
            <CardHeader>
              <div className="form-row align-items-center">
                <div className="col-auto">
                  <Input
                    type="text"
                    data-cy="competenceName"
                    value={this.state.CompetenceParams.Name}
                    onChange={(e) => this.searchByName(e.target.value)}
                    id="inlineFormInput"
                    placeholder={t('applicants.SEARCH_BY_NAME')}
                  />
                </div>
                <div className="col-auto" style={{ width: '250px' }}>
                  <Select
                    name="onSelectJobStatusChanged"
                    value={this.state.CompetenceParams.Type}
                    onChange={(item) => this.onSelectTypeChanged(item)}
                    options={utils.getCompetenceType()}
                    isClearable={true}
                  />
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    data-cy="btnClearCompetences"
                    onClick={this.ResetParams.bind(this)}
                  >
                    {t('common.CLEAR_FILTERS')}
                  </button>
                </div>
              </div>
            </CardHeader>
            <CardBody>
              <CompetencesTable
                competences={this.state.competences}
                counting={(this.state.selectedPage - 1) * this.state.itemsPerPage}
                onItemClicked={(id, purpose) => this.handleTableRequest(id, purpose)}
              />
            </CardBody>
            <CardFooter>
              <Pagination
                totalItems={this.state.totalItems}
                pageSize={this.state.itemsPerPage}
                activePage={this.state.selectedPage}
                onPaginationSelect={(item) => this.handlePaginationSelected(item)}
                onTableSizeSelect={this.handleChangeSelect.bind(this, 'tags')}
                pagination={this.state.pagination}
              />
            </CardFooter>
          </Card>
          // </FadeIn>
        )}
      </ContentWrapper>
    );
  }
}

export default withTranslation('translations')(Competences);
